// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore'; // 👈 add this

const firebaseConfig = {
    apiKey: "AIzaSyCv-zTm5_9XMaKfYX5iPRCg0_21Ck7e_Ts",
    authDomain: "draftchallenge.firebaseapp.com",
    projectId: "draftchallenge",
    storageBucket: "draftchallenge.firebasestorage.app",
    messagingSenderId: "170840714512",
    appId: "1:170840714512:web:af94eb5a9b6ff042564995",
    measurementId: "G-0FVXW77L3H"
  };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); // 👈 initialize Firestore

export { auth, db };
export default app;
